import { metaReducers } from './+state/frailty.metareducer';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FrailtyCustomService } from '@medlogic/medlogic/medlogic-data-access';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { FrailtyEffects } from './+state/frailty.effects';
import { frailtyReducer } from './+state/frailty.reducer';

const MODULES = [
  CommonModule
];

const STATE_MODULES = [
  StoreModule.forFeature('frailty', frailtyReducer, {metaReducers}),
  EffectsModule.forFeature([FrailtyEffects]),
];

const SERVICES = [
  FrailtyCustomService
]

@NgModule({
  imports: [MODULES, STATE_MODULES],
  providers: [SERVICES]
})


export class StateFrailtyModule {}
